import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

import TabPanel from '../front_stage/tab_panel_controller'
import FollowUP from '../front_stage/follow_up_controller'
import SetConversionCookies from '../front_stage/set_conversion_cookies_controller'
import FixedArea from './fixed_area_controller'
import FooterScroll from '../front_stage/footer_scroll_controller'
import StructuredDataFaq from '../front_stage/structured_data_faq_controller'

application.register('tab-panel', TabPanel)
application.register('follow-up', FollowUP)
application.register('set-conversion-cookies', SetConversionCookies)
application.register('fixed-area', FixedArea)
application.register('footer-scroll', FooterScroll)
application.register('structured-data-faq', StructuredDataFaq)

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
